import React from 'react';
interface DigitalChainProps {
  steps: string[];
  /** How many nodes have been revealed so far. */
  revealed: number;
  /** When false, the last node sits outside the digital chain. */
  complete?: boolean;
  /** Small tag shown against the last node. */
  finalTag?: string;
  orientation?: 'vertical' | 'horizontal';
}

/**
 * The campaign's central device: four digital steps in one connected chain, and
 * a fifth that either breaks it (manual) or completes it (Precision Grip).
 */
export function DigitalChain({
  steps,
  revealed,
  complete = false,
  finalTag,
  orientation = 'vertical'
}: DigitalChainProps) {
  const lastIndex = steps.length - 1;
  if (orientation === 'horizontal') {
    return <ol className="flex items-start" data-id="element-58" data-mp="2o9hg6xrugb1j">
        {steps.map((step, index) => {
        const isFinal = index === lastIndex;
        const broken = isFinal && !complete;
        const visible = revealed > index;
        return <li key={step} className={`flex flex-1 flex-col items-center transition-[opacity,transform] duration-300 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'}`} data-id="element-59" data-mp="1vq0pwltjeekf" data-mpi={index}>
              <div className="flex w-full items-center" data-id="element-60" data-mp="3em8r85ajsw93">
                <span className={`h-px flex-1 ${index === 0 ? 'bg-transparent' : broken ? 'bg-transparent' : 'bg-solventum-primary/45'}`} data-id="element-61" data-mp="39oqf6618i0wv" />
                <span className={`h-2 w-2 flex-shrink-0 rounded-full transition-colors duration-300 ease-out ${broken ? 'border border-dashed border-white/45 bg-transparent' : 'bg-solventum-primary'}`} data-id="element-62" data-mp="2vofrfbv812fx" />
                <span className={`h-px flex-1 ${isFinal ? 'bg-transparent' : 'bg-solventum-primary/45'}`} data-id="element-63" data-mp="ozat1ocyn0dk" />
              </div>
              <span className={`mt-2 text-center font-headline text-[9px] font-bold uppercase leading-tight tracking-[0.1em] transition-colors duration-300 ease-out ${broken ? 'text-white/45' : isFinal ? 'text-solventum-primary' : 'text-white/75'}`} data-id="element-64" data-mp="2o680w99z2uj5">
                {step}
              </span>
            </li>;
      })}
      </ol>;
  }
  return <ol className="flex flex-col" data-id="element-65" data-mp="2t3hodjdsww4c">
      {steps.map((step, index) => {
      const isFinal = index === lastIndex;
      const broken = isFinal && !complete;
      const visible = revealed > index;
      const nextBroken = index === lastIndex - 1 && !complete;
      return <li key={step} className={`relative pl-7 ${isFinal ? 'pb-0' : 'pb-5'} transition-[opacity,transform] duration-300 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-66" data-mp="1lrqyyya84zuh" data-mpi={index}>
            {!isFinal && <span aria-hidden="true" className={`absolute left-[5px] top-3 h-full ${nextBroken ? 'border-l border-dashed border-white/20' : 'w-px bg-solventum-primary/45'}`} data-id="element-67" data-mp="1o4bdfkkw0h2i" />}

            <span aria-hidden="true" className={`absolute left-0 top-1.5 h-2.5 w-2.5 rounded-full transition-colors duration-300 ease-out ${broken ? 'border border-dashed border-white/45 bg-transparent' : 'bg-solventum-primary'}`} data-id="element-68" data-mp="qj5kag9ihd8e" />

            <div className={`flex items-baseline gap-2 transition-transform duration-300 ease-out ${broken ? 'translate-x-2' : 'translate-x-0'}`} data-id="element-69" data-mp="7r4eetybkmph">
              <span className={`font-headline text-[15px] font-bold uppercase tracking-[0.14em] transition-colors duration-300 ease-out ${broken ? 'text-white/50' : isFinal ? 'text-solventum-primary' : 'text-white'}`} data-id="element-70" data-mp="3b6fml3kzbke5">
                {step}
              </span>
              {isFinal && finalTag && <span className={`rounded-full border px-2 py-0.5 font-headline text-[9px] font-bold uppercase tracking-[0.14em] transition-colors duration-300 ease-out ${broken ? 'border-white/25 text-white/45' : 'border-solventum-primary/50 text-solventum-primary'}`} data-id="element-71" data-mp="3ut4z9p8oxjcx">
                  {finalTag}
                </span>}
            </div>
          </li>;
    })}
    </ol>;
}